/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Fade from "react-reveal/Fade"
import Button from "@/containers/MoneyFortune/View/homeWEB3/Button"
import Ball from "@/common/assets/image/moneyFortune/web3Plus/resultball.webp"
import NextImg from "@/common/components/NextImg/index"

export default function CompleteForm({
  setPage,
  setName,
  name,
  setQAAnimation,
  QAAnimation,
  summaryCount,
  setEmail,
  email,
  GetAndShare
}) {
  const [CanSubit, setCanSubit] = useState(true)

  const nameHolder = e => {
    const value = e.target.value
    setName(value)
  }
  const emailHolder = e => {
    const value = e.target.value
    setEmail(value)
  }

  const handleKeyDown = event => {
    event.preventDefault()

    submit()
  }

  useEffect(() => {
    if (email.length < 1) {
      setCanSubit(true)
    } else if (validateEmail(email) !== false) {
      setCanSubit(true)
    } else {
      setCanSubit(false)
    }
  }, [emailHolder, nameHolder])

  const validateEmail = emailtest => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
    return emailRegex.test(emailtest)
  }

  const submit = () => {
    if (CanSubit === false) {
      return
    }
    {
      summaryCount()
      setQAAnimation(!QAAnimation)
      setTimeout(() => {
        setPage(pre => pre + 1)
      }, 3000)
    }
  }
  return (
    <Wrapper>
      <Title>完成測驗</Title>
      <div>
        <Title className="desc">
          歡迎留下email，免費訂閱Web3+周報，掌握最新應用趨勢！
        </Title>
        <Title className="s">
          訂閱Web3+周報、加入會員，就可以抽價值4千元 CoolWallet冷錢包
        </Title>
      </div>
      <Form className="completeForm" onSubmit={handleKeyDown}>
        {GetAndShare.completeType.includes("name") && (
          <Input
            type="text"
            placeholder={"請輸入你的名字"}
            onChange={nameHolder}
          />
        )}

        {GetAndShare.completeType.includes("email") && (
          <InputWrapper>
            <BGWrapper>
              <Decoration className={"c1"} />
              <Decoration className={"c2"} />
              <Decoration className={"c3"} />
              <Decoration className={"c4"} />
            </BGWrapper>
            <Input
              type="text"
              value={email}
              placeholder={"請輸入你的Email"}
              onChange={emailHolder}
            />
          </InputWrapper>
        )}
        <ButtonOutWrapper>
          <BallWrapper>
            <NextImg src={Ball} />
          </BallWrapper>
          <ButtonWrapper className={CanSubit === false ? "disable" : ""}>
            <Fade>
              <Button content="生成結果" onClick={submit} />
            </Fade>
          </ButtonWrapper>
        </ButtonOutWrapper>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  font-size: 300;
  color: #fff;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;

  .completeForm {
    display: flex;
    flex-direction: column;
    z-index: 1;

    align-items: center;
  }
`
const Title = styled.h2`
  font-size: 32px;
  text-align: center;
  z-index: 1;
  color: #00fff0;
  &.desc {
    font-size: 24px;
    color: #fff;
    text-shadow: 0 0 20px #00fff0;
    margin-bottom: 12px;
    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
  &.s {
    color: #fff;
    text-shadow: 0 0 20px #00fff0;
    font-size: 20px;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`

const InputWrapper = styled.div`
  position: relative;
  width: clamp(300px, 100%, 580px);
`
const Input = styled.input`
  border: 1px solid #00fff0;
  border-radius: 8px;
  padding: 24px 14px;
  background-color: rgba(255, 255, 255, 0);
  width: 100%;
  font-size: 20px;
  color: #00fff0;
  text-align: center;
  font-weight: 700;
  transition: 0.3s;
  &::-webkit-input-placeholder {
    color: #00fff0;
    font-weight: 300;
  }
  &:focus {
    box-shadow: 0 0 20px #00fff0;
  }
`

const Form = styled.form``
const BGWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -2;
`
const Decoration = styled.div`
  --decoration: 16px;
  position: absolute;
  border-top: 5px solid #00ffeeba;
  border-left: 5px solid #00ffeeba;
  width: var(--decoration);
  height: var(--decoration);
  border-radius: 16px 0 0 0;
  &.c1 {
    top: -2px;
    left: -2px;
  }
  &.c2 {
    top: -2px;
    right: -2px;
    transform: rotate(90deg);
  }
  &.c3 {
    bottom: -2px;
    left: -2px;
    transform: rotate(270deg);
  }
  &.c4 {
    bottom: -2px;
    right: -2px;
    transform: rotate(180deg);
  }
`
const ButtonOutWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  /* background-color: #fff; */
`
const BallWrapper = styled.div`
  width: 200px;
  left: calc(50% + 5px);
  z-index: -1;
`
const ButtonWrapper = styled.div`
  /* border: 1px solid #fff; */
  position: absolute;
  top: 50%;
  left: calc(50% - 5px);
  transform: translate(-50%, -50%);
  max-width: 300px;
  width: 300px;
  padding: -0 12px;
  transition: all 0.3s;
  cursor: pointer;
  &.disable {
    opacity: 0.5;
    cursor: default;
    z-index: -1;
  }
`
